import { UserActions, UserTypeKeys } from '../actions';
import { UserDTO } from '../dto/user.dto';
import { AccountDTO } from '../dto/account.dto';

interface UserState {
  currentUser: UserDTO;
  loading: boolean;
  error: null;
  settings: Object;
  currentAccount: AccountDTO;
  teamMembers: UserDTO[];
}

const getInitialState = () => {
  return {
    currentUser: null,
    loading: true,
    error: null,
    settings: {},
    currentAccount: null,
    teamMembers: null
  };
};

export const user = (state: UserState = getInitialState(), action: UserActions) => {
  switch (action.type) {
    case UserTypeKeys.FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.settings
      };

    case UserTypeKeys.FETCH_USER_START:
      return {
        ...state,
        loading: true
      };

    case UserTypeKeys.FETCH_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case UserTypeKeys.FETCH_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.user,
        currentAccount: action.currentAccount,
        loading: false
      };

    case UserTypeKeys.FETCHING_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        teamMembers: [].concat(state.currentUser).concat(action.teamMembers || [])
      };
  }
  return state;
};
